import { APPLMSJSTarget, CustomTargetURL, FoundationsJSTargetAFHTicketViewer, FoundationsJSTargetDrillThruDelete, FoundationsJSTargetDrillThruSet, FoundationsJSTargetGenericObjectViewer, FoundationsJSTargetPatientViewer, FoundationsJSTargetSmartObjectViewer, FoundationsJSTargetStatPortalID, handleDefaultCase, LinkResult } from '../DrillThruItems/HandleFoundationsJSTarget'
import { ILinkProps } from '../DrillThruItems/DrillThruTypes'
import { isSecurityFeatureAllowed } from '../../../Utils'

function LinkSetupLogic(props: any) {

  let currentColumn = props.currentColumn
  let cellTitle = props.cellTitle
  let functionParamsString = props.functionParamsString
  let isAllowedOCV = props.isAllowedOCV
  var textLength = props.rowObject?.[props.headerText]?.length * 7 > 200 ? 200 : props.rowObject?.[props.headerText]?.length * 7
  var colMinWidth = props.mdsColumnData?.[props.colCounter]?.dataType == 'HLText' ? textLength + 'px' : 'auto'
  var colMaxWidth = props.mdsColumnData?.[props.colCounter]?.dataType == 'HLText' ? '90%' : 'none'
  var colWhiteSpace = props.mdsColumnData?.[props.colCounter]?.dataType == 'HLText' ? 'normal' : 'inherit'
  // var cellTitle =
  //     props.mdsColumnData[colCounter]?.dataType == 'HLText' ? jsonRow[colKey] : ''
  cellTitle = currentColumn?.dataType == 'HLText' ? 'cell title' : 'title is null'
  if (currentColumn?.javascriptTarget !== '' || currentColumn?.javascriptTarget) {
    let templatedParams: any = []
    let allowedPrivileges = currentColumn['AllowedPrivileges']
    
    if (allowedPrivileges && currentColumn['javascriptTarget'] === 'FoundationsJSTargetSmartObjectViewer') {
      let jsonPrivilegesList = JSON.parse(allowedPrivileges)
      let privilegesList = jsonPrivilegesList['privilegeslist']
      isAllowedOCV = isSecurityFeatureAllowed(
        props.JSONRowDataLists.featureList,
        privilegesList
      )
    }
    if (isAllowedOCV || !allowedPrivileges) {
      functionParamsString = currentColumn['javascriptTargetParams']
      let namedParams = currentColumn['javascriptTargetParams'].match(/\$[\w\s]+\$/gi)
      if (namedParams) {
        for (let i = 0; i < namedParams.length; i++) {
          templatedParams.push(namedParams[i])
        }
      }
      let indexedParams = currentColumn['javascriptTargetParams'].match(/\$\d+/gi)
      if (indexedParams) {
        for (let i = 0; i < indexedParams.length; i++) {
          templatedParams.push(indexedParams[i])
        }
      }
      let functionParamsArr = []
      for (let match in templatedParams) {
        let positionalParam: any = templatedParams[match].replace(/\$/g, '')
        positionalParam = isNaN(positionalParam) ? props.tableHeading.findIndex((item: string) => item.toLowerCase() === positionalParam.toLowerCase()) : Number(positionalParam)
        //   if (props.JSONRowDataLists.jsonRowEncrypyedList[props.colCounter] == null) {
        //     functionParamsString = functionParamsString.replace(
        //         templatedParams[match],
        //         jsonRowList[positionalParam]
        //     )
        // } else {
        //     let jsonRowEncrypyedObject = jsonRowEncrypyedList[colCounter]
        //     functionParamsString = functionParamsString.replace(
        //         templatedParams[match],
        //         jsonRowEncrypyedObject.EncryptedKey
        //     )
        // }
        functionParamsArr.push(props.JSONRowDataLists.jsonRowList[positionalParam])
        functionParamsString = functionParamsString.replace(
          templatedParams[match],
          props.JSONRowDataLists.jsonRowList[positionalParam]
        )
      }
    }

    const regExp = /"([^"]+)":\s*("(?:[^"\\]|\\.)*"|\d+)/g
    const matchRegex = functionParamsString.match(regExp)

    const LinkSetUpCallBack = (OcvDetails: any) => {
      props.LinkSetUpCallBack(
        OcvDetails
      )
    }

    const targetHandlers = (targetType: string) => { //FP-11657 - Using switch case because we need to use default case in the case of Form engine Target type, which is not possible in previous implementation
      switch (targetType) {
        case 'FoundationsJSTargetGenericObjectViewer':
          return FoundationsJSTargetGenericObjectViewer(
            functionParamsString,
            currentColumn,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            props.launcherMode,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
            LinkSetUpCallBack,
          )

        case 'FoundationsJSTargetDrillThruDelete':
          return FoundationsJSTargetDrillThruDelete(
            currentColumn,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            matchRegex,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
        case 'FoundationsJSTargetAFHTicketViewer':
          return FoundationsJSTargetAFHTicketViewer(
            functionParamsString,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
        case 'FoundationsJSTargetPatientViewer':
          return FoundationsJSTargetPatientViewer(
            matchRegex,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            props.JSONRowDataLists.featureList,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
        case 'FoundationsJSTargetSmartObjectViewer':
          return FoundationsJSTargetSmartObjectViewer(
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            props.JSONRowDataLists.jsonRowEncrypyedList,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
            LinkSetUpCallBack
          )
        case 'FoundationsJSTargetDrillThruSet':
          return FoundationsJSTargetDrillThruSet(
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
        case 'FoundationsJSTargetStatPortalID':
          return FoundationsJSTargetStatPortalID(
            functionParamsString,
            currentColumn,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            props.launcherMode,
            props.drillThruVUObj,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
            LinkSetUpCallBack,
          )
        case 'APPLMSJSTarget':
          return APPLMSJSTarget(
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            matchRegex,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
            LinkSetUpCallBack,
          )
        case 'FoundationsJSTargetURL':
          return CustomTargetURL(
            functionParamsString,
            props.rowCounter,
            props.colCounter,
            props.vuId,
            cellTitle,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
        default:
          return handleDefaultCase(
            props.rowCounter,
            functionParamsString,
            props.colCounter,
            props.vuId,
            currentColumn,
            props.JSONRowDataLists,
            props.drillThruVUObj,
            props.data_isEnabledAutoNavigation,
            props.data_drillThruSearchObj,
            cellTitle,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
          )
      }
    }

    let targetType;
    if (!currentColumn?.javascriptTarget) {
      targetType = ""
    }
    else{
      targetType = currentColumn?.javascriptTarget
    }
    // Form javascriptTarget will not be a hardcoded string all the time
    let handlerResponse = targetHandlers(targetType);
    if (handlerResponse === undefined && targetType !== undefined) {
      handlerResponse = handleDefaultCase(
            props.rowCounter,
            functionParamsString,
            props.colCounter,
            props.vuId,
            currentColumn,
            props.JSONRowDataLists,
            props.drillThruVUObj,
            props.data_isEnabledAutoNavigation,
            props.data_drillThruSearchObj,
            cellTitle,
            colMinWidth,
            colMaxWidth,
            colWhiteSpace,
      )
    }
    
    return handlerResponse;

  } else {
    return {
      LinkValues: {
        "id": `mdsc_${props.rowCounter}_${props.colCounter}_${props.vuId}`,
        "title": { cellTitle },
        "href": "",
        "onContextMenu": (e:any) => {},
        "style": {
          "cursor": "pointer",
          "minWidth": { colMinWidth },
          "maxWidth": { colMaxWidth },
          "whiteSpace": { colWhiteSpace }
        }
      },
      IsLink: false
    }
  }
}

export default LinkSetupLogic